import React from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';

import { titleStyle } from '@styles/common';

/** 포트폴리오 상세 > 손익재무 > 손익/재무 차트 스켈레톤 */
const ProfitAndFinanceSkeleton = () => {
  return (
    <>
      <div css={container}>
        <div css={[titleStyle, wrapper]}>
          <Skeleton variant="text" width={80} />
          <Skeleton
            variant="rectangular"
            width={'100%'}
            height={390}
            sx={{
              borderRadius: '10px',
              boxShadow: '0px 0px 20px 0px rgba(206, 208, 214, 0.5)',
              marginTop: '20px',
            }}
          />
        </div>

        <div css={[titleStyle, wrapper]}>
          <Skeleton variant="text" width={80} />
          <Skeleton
            variant="rectangular"
            width={'100%'}
            height={390}
            sx={{
              borderRadius: '10px',
              boxShadow: '0px 0px 20px 0px rgba(206, 208, 214, 0.5)',
              marginTop: '20px',
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ProfitAndFinanceSkeleton;

const container = css`
  display: flex;
  gap: 40px;
`;

const wrapper = css`
  flex-direction: column;
  align-items: flex-start;
  width: 50%;
`;
